import { Link } from "react-router-dom";

/**
 * Minimal markdown-lite inline renderer for **bold** and [text](path) links.
 * Returns an array of React nodes suitable for use inside <p>.
 */
export function renderInline(text) {
    const parts = [];
    const re = /(\*\*[^*]+\*\*|\[[^\]]+\]\([^)]+\))/g;
    let last = 0;
    let m;
    let key = 0;
    while ((m = re.exec(text)) !== null) {
        if (m.index > last) parts.push(text.slice(last, m.index));
        const tk = m[0];
        if (tk.startsWith("**")) {
            parts.push(<strong key={key++}>{tk.slice(2, -2)}</strong>);
        } else {
            const lm = /\[([^\]]+)\]\(([^)]+)\)/.exec(tk);
            parts.push(
                <Link
                    key={key++}
                    to={lm[2]}
                    className="text-[var(--navy)] underline decoration-[var(--amber)] decoration-2 underline-offset-2 font-medium"
                >
                    {lm[1]}
                </Link>
            );
        }
        last = re.lastIndex;
    }
    if (last < text.length) parts.push(text.slice(last));
    return parts;
}

/**
 * Strip markdown-lite syntax from a string so it can be safely embedded in JSON-LD.
 */
export function stripMarkdown(str) {
    return (str || "")
        .replace(/\*\*([^*]+)\*\*/g, "$1")
        .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
}
